import { defineMessages } from 'react-intl'

export const s2dMessages = defineMessages({
  sending: {
    id: 's2d.sending',
    defaultMessage: 'Sending {asset}'
  },
  returnToRoute: {
    id: 's2dMessages.returnToRoute',
    defaultMessage: 'Return to Route'
  },
  sendTo: {
    id: 's2dMessages.sendTo',
    defaultMessage: 'Send to {device}'
  },
  enjoyYrRide: {
    id: 's2dMessages.enjoyYrRide',
    defaultMessage: 'Enjoy your Ride!'
  },
  createAccount: {
    id: 's2dMessages.createAccount',
    defaultMessage: 'Create Account'
  }
})
